<template>
  <div>
    <header class="bg-white shadow">
      <div class="max-w-7xl mx-auto py-4 px-4 sm:px-4 lg:px-8">
        <div class="px-3 flex flex-col">
          <div class="leading-none rounded-md font-bold pb-3 flex items-center">
            <div @click="goTo('Admin Users')">
              <v-mdi name="mdi-arrow-left" class="cursor-pointer mr-1" />
            </div>
            Retour à la liste des utilisateurs
          </div>
          <div class="flex gap-3">
            <a
              @click="goTo('Admin User Details')"
              v-bind:class="{ 'font-bold': $route.name === 'Admin User Details' }"
              class="py-1 rounded-md text-sm font-medium hover:text-primary cursor-pointer"
            >
              Informations
            </a>
          </div>
        </div>
      </div>
    </header>
    <main>
      <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div class="px-4 py-3 sm:px-0">
          <router-view />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "User",
  async mounted() {
    await this.$store.dispatch("users/fetchById", this.$route.params.idUser);
  },
  beforeDestroy() {
    this.$store.commit("users/resetActiveUser")
  },
  methods: {
    goTo(route) {
      this.$router.push({ name: route });
    },
  },
};
</script>

<style scoped></style>
